import React, { useEffect, useRef, useState } from "react";
import { gsap } from "gsap";

const Cursor = () => {
  const cursorRef = useRef(null);
  const fireRingRef = useRef(null);
  const pos = useRef({ x: 0, y: 0 });
  const mouse = useRef({ x: 0, y: 0 });
  const speed = 0.2;
  const [isMoving, setIsMoving] = useState(false);
  let moveTimeout = useRef(null);

  useEffect(() => {
    const onMouseMove = (e) => {
      mouse.current = { x: e.clientX, y: e.clientY };
      setIsMoving(true);

      clearTimeout(moveTimeout.current);
      moveTimeout.current = setTimeout(() => setIsMoving(false), 300);
    };

    window.addEventListener("mousemove", onMouseMove);

    gsap.ticker.add(() => {
      pos.current.x += (mouse.current.x - pos.current.x) * speed;
      pos.current.y += (mouse.current.y - pos.current.y) * speed;

      // Cursor movement
      gsap.set(cursorRef.current, {
        x: pos.current.x,
        y: pos.current.y,
      });

      // Fire ring effect
      gsap.set(fireRingRef.current, {
        x: pos.current.x,
        y: pos.current.y,
        scale: isMoving ? 1.1 : 1, // Slight pulse effect when moving
        opacity: isMoving ? 0.8 : 0.5, // Subtle glow when idle
      });
    });

    return () => {
      window.removeEventListener("mousemove", onMouseMove);
    };
  }, [isMoving]);

  return (
    <>
      {/* Small Center Cursor */}
      <div
        ref={cursorRef}
        className="fixed w-3 h-3 bg-white rounded-full pointer-events-none 
                   shadow-md transform -translate-x-1/2 -translate-y-1/2"
      />

      {/* Persistent Fire Ring Around Cursor */}
      {/* <div
        ref={fireRingRef}
        className="fixed w-10 h-10 rounded-full border-[1px] border-blue-500 
                  shadow-[0_0_10px_rgba(0,150,255,0.5)] pointer-events-none 
                  transform -translate-x-1/2 -translate-y-1/2 opacity-50 transition-all duration-200"
      /> */}
    </>
  );
};

export default Cursor;
